import { Formik } from 'formik';
import React, { useMemo, useState } from 'react';

import SwitchField from '@components/Form/SwitchField';
import { Theme } from '@interfaces/global';
import { updateProfile } from '@utils/backend-api/userProfile';

import StepContainer from './StepContainer';

export interface Interest {
  key: string;
  label: string;
  default: boolean;
}

interface StepInterestsProps {
  interests: Interest[];
  nextStep: () => void;
}

const StepInterests = ({ interests = [], nextStep }: StepInterestsProps) => {
  const [selectedInterests, setSelectedInterests] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState();
  const initialValues = useMemo(
    () =>
      interests.reduce((interestFields, interest) => {
        interestFields[interest.key] = interest.default;
        return interestFields;
      }, {}),
    [interests]
  );

  const handleSwitchToggle = (values) => {
    setSelectedInterests(Object.keys(values)?.filter((key) => values[key]));
  };

  const handleFormSaving = async () => {
    setIsSaving(true);
    try {
      await updateProfile({ interests: selectedInterests });
      nextStep();
    } catch (err) {
      setError(err.message);
    }
    setIsSaving(false);
  };

  return (
    <StepContainer
      heading="Be The First to Know"
      subheading="What would you like to be updated on?"
      nextStep={nextStep}
      disableContinue={isSaving}
      error={error}
      onContinue={handleFormSaving}
    >
      <Formik initialValues={initialValues} onSubmit={null}>
        {({ values }) => (
          <ul className="onboarding-togglelist">
            {interests?.map((interest) => (
              <li key={interest.key}>
                {interest.label}
                <SwitchField
                  colorTheme={Theme.Light}
                  name={interest.key}
                  onChangeCallBack={() => handleSwitchToggle(values)}
                />
              </li>
            ))}
          </ul>
        )}
      </Formik>
    </StepContainer>
  );
};

export default StepInterests;
